<template>
    <v-container grid-list-md fluid>
        <v-layout row wrap fill-height>
            <v-card outlined class="pa-2" style="min-height: 418px; min-width: 100%;">
                <v-sheet class="d-flex pa-2 light-bg">
                    <p class="text-color">Today's Visits</p>
					<v-spacer></v-spacer>
					<div class="ml-5 count-bg-color"><p class="float_left pr-2 pl-2 letter-spacing-2">{{ count |TwoDigitNumber }}</p></div>
                </v-sheet>
              
                <div class="mt-3">
                    <v-data-table 
                    :headers="headers" 
                    :items="visits"
                   :footer-props="{'items-per-page-options': [5]}" 
                    :items-per-page="5" 
                    :loading="is_loading"
                    item-key="name"
                    class="elevation-0"
                    >
                        <template v-slot:body="{ items }" v-if="!is_loading && count!='0'">
                            <tbody>
                                <tr v-for="item in items" :key="item.name">
                                    <td v-if="item.visitor">
                                        <router-link :to="{ name:'showVisitorDetails',params: { id:item.visitor.id } }">
                                            {{ item.visitor.name |capitalize}}
                                        </router-link>
                                    </td>
                                    <td v-else>-</td>
                                    <td>{{ formatDateTime(item.time) }}</td>
                                    <td>{{ item.type.toUpperCase().replace(/_/g, " ")}}</td>
                                </tr>
                            </tbody>
                        </template>
                        <template v-slot:loading> Loading... Please wait </template>
                        <template v-slot:no-results> No data available </template>
                    </v-data-table>
                </div>
            </v-card>
        </v-layout>
    </v-container>
</template>

<script>
export default {
    methods: {
        getTodaysVisits: function () {
             this.is_loading = true;
            axios.get(`${process.env.VUE_APP_API_URL}/api/dashboard/todaysvisits`).then((response) => {
                
                if (response.data.status == 1) {
                    this.visits = response.data.visits;
                    this.count = response.data.count;
                    this.is_loading = false;
                }
            }).catch((error) => {
                console.log(error);

            }).finally(() => {
                {

                }
            });
        },
        
    },
    computed: {

    },
    data: () => {
        return {
            count: '',
            visits: [],
            is_loading: false,
            total_items: 10,
            options: {},

            headers: [{
                    text: 'Visitor',
                    value: 'visitor.name',
                    sortable: true
                },
                {
                    text: 'Time',
					value: 'time',
					 sortable: false
                },
                {
                    text: 'Type',
					value: 'type',
					 sortable: false
                },
            ]
        }
    },
    mounted() {
        this.getTodaysVisits();
    }
};
</script>
